import { isTaiwanSymbol } from '@invest-copilot/shared';

export type LimitStatus = 'up' | 'down';

/**
 * 台股漲跌停偵測（美股無漲跌停制度，一律回 null）。
 * 以「對昨收的當日漲跌幅」貼著 ±10% 判定：因升降單位 rounding，實際鎖死時漲跌幅常落在
 * 9.6%~10%（例：2478.TW 鎖漲停 +9.88%），故沿用 MiniKLine 既有的 9.6 門檻保持一致。
 */
export function limitStatus(symbol: string | undefined, changePct: number | null | undefined): LimitStatus | null {
  if (!symbol || changePct == null || !Number.isFinite(changePct) || !isTaiwanSymbol(symbol)) return null;
  if (changePct >= 9.6) return 'up';
  if (changePct <= -9.6) return 'down';
  return null;
}

export function limitLabel(status: LimitStatus): string {
  return status === 'up' ? '漲停' : '跌停';
}
